import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_DefineEvents } from "../shared/data.service";
import { InsertEventRequest } from "../shared/InsertEventRequest";
import { ScheduleEventRequest } from "../shared/ScheduleEventRequest";
import { UpdateEventRequest } from "../shared/UpdateEventRequest";
import { UpdateScheduleRequest } from "../shared/UpdateScheduleRequest";
import * as moment from "moment";

@Component({
	selector: "app-groups-edit-event",
	templateUrl: "./groups-edit-event.component.html",
	styleUrls: ["./groups-edit-event.component.css"],
})
export class GroupsEditEventComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private defineService: DataService_DefineEvents,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		//Data from parent
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.EventID = this.dialogConfig.data.EventID;
		this.ScheduleID = this.dialogConfig.data.ScheduleID;
		this.EventDescriptionID = this.dialogConfig.data.EventDescriptionID;

		if (this.ScheduleID > 0) {
			this.lstRecurranceType = [
				{
					ID: 1,
					Desc: "Weekly",
				},
				{
					ID: 2,
					Desc: "Monthly",
				},
				{
					ID: 3,
					Desc: "Yearly",
				},
			];

			this.loadSchedule();
		} else {
			this.ChangeSchedule = false;

			this.lstRecurranceType = [
				{
					ID: 0,
					Desc: "Once",
				},
			];

			this.loadEvent();
		}
	}

	///////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////

	//Edit
	EventID: any = -1;
	ScheduleID: any = -1;
	EventDescriptionID: any = -1;
	MainData: any;
	loading: any = true;
	ChangeSchedule: any = true;

	Saving: any = false;

	SchoolID: any = 0;

	EventDescShort: any = "";
	EventDescLong: any = "";
	EventLocation: any = "";
	EventDT: Date = new Date();
	SpecifyGateOpenTime: any = false;
	GatesOpenTime: Date = new Date();
	StartTime: Date = new Date();
	EndTime: Date = new Date();
	ValidationCheckOnly: any = false;

	RecurranceTypeID: any = 0;
	lstRecurranceType: any = [];

	//
	//Recurring
	//

	//Weekly
	WeekRecurCount: any = 1;
	WeekDaySunInd: any = false;
	WeekDayMonInd: any = false;
	WeekDayTueInd: any = false;
	WeekDayWedInd: any = false;
	WeekDayThuInd: any = false;
	WeekDayFriInd: any = false;
	WeekDaySatInd: any = false;

	RecurrancePatternTypeID: any = 1; //Month and Year options

	//Monthly
	//Opt 1
	MonthEveryDOM: any = 1;
	MonthEveryRecurCount: any = 1;
	//Opt 2
	MonthOnWeekNbr: any = 1;
	MonthOnDOW: any = 1;
	MonthOnRecurCount: any = 1;

	//Yearly
	//Opt 1
	YearEveryMOY: any = 1;
	YearEveryDOM: any = 1;
	//Opt 2
	YearOnWeekNbr: any = 1;
	YearOnDOW: any = 1;
	YearOnMonth: any = 1;

	//All (Range)
	RangeStartDate: Date = new Date();
	RecurranceRangeTypeID: any = 1; //1 No End, 2 End after x times, 3 By End Date
	RangeEndOccurancesTotal: any = 10; //Opt 2
	RangeEndDate: Date = new Date(); //Opt 3

	lstWeekNbr: any = [
		{
			ID: 1,
			Desc: "1st",
		},
		{
			ID: 2,
			Desc: "2nd",
		},
		{
			ID: 3,
			Desc: "3rd",
		},
		{
			ID: 4,
			Desc: "4th",
		},
		{
			ID: 5,
			Desc: "Last",
		},
	];

	lstDay: any = [
		{
			ID: 1,
			Desc: "Monday",
		},
		{
			ID: 2,
			Desc: "Tuesday",
		},
		{
			ID: 3,
			Desc: "Wednesday",
		},
		{
			ID: 4,
			Desc: "Thursday",
		},
		{
			ID: 5,
			Desc: "Friday",
		},
		{
			ID: 6,
			Desc: "Saturday",
		},
		{
			ID: 0,
			Desc: "Sunday",
		},
	];

	lstMonth: any = [
		{
			ID: 1,
			Desc: "January",
		},
		{
			ID: 2,
			Desc: "February",
		},
		{
			ID: 3,
			Desc: "March",
		},
		{
			ID: 4,
			Desc: "April",
		},
		{
			ID: 5,
			Desc: "May",
		},
		{
			ID: 6,
			Desc: "June",
		},
		{
			ID: 7,
			Desc: "July",
		},
		{
			ID: 8,
			Desc: "August",
		},
		{
			ID: 9,
			Desc: "September",
		},
		{
			ID: 10,
			Desc: "October",
		},
		{
			ID: 11,
			Desc: "November",
		},
		{
			ID: 12,
			Desc: "December",
		},
	];

	errorMessage: any = "";

	///////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////////////
	loadSchedule() {
		this.loading = true;

		var result = this.defineService.C9ScheduleGet(this.ScheduleID);
		result.subscribe(
			(response) => {
				this.MainData = response[0];

				var specTime = false;

				var doorTime = new Date(this.MainData.EventDescription.DoorsOpenTime);
				var sTime = new Date(this.MainData.EventDescription.StartTime);

				//Specify doors open time if it is different from start time
				specTime = moment(doorTime).format("HH:mm") == moment(sTime).format("HH:mm") ? false : true;

				var reDate = new Date(this.MainData.RangeEndDate);

				if (reDate.getFullYear() < 2000) {
					reDate = new Date();
				}

				//
				// Update fields
				//
				this.EventDescShort = this.MainData.EventDescription.EventDescShort;
				this.EventDescLong = this.MainData.EventDescription.EventDescLong;
				this.EventLocation = this.MainData.EventDescription.EventLocation;
				this.EventDT = new Date(this.MainData.RangeStartDate);
				this.SpecifyGateOpenTime = specTime;
				this.GatesOpenTime = new Date(this.MainData.EventDescription.DoorsOpenTime);
				this.StartTime = new Date(this.MainData.EventDescription.StartTime);
				this.EndTime = new Date(this.MainData.EventDescription.EndTime);
				this.ValidationCheckOnly = this.MainData.EventDescription.ValidateOnly;
				this.RecurranceTypeID = this.MainData.RecurranceTypeID;
				this.WeekRecurCount = this.MainData.WeekRecurCount <= 0 ? 1 : this.MainData.WeekRecurCount;
				this.WeekDaySunInd = this.MainData.WeekDaySunInd;
				this.WeekDayMonInd = this.MainData.WeekDayMonInd;
				this.WeekDayTueInd = this.MainData.WeekDayTueInd;
				this.WeekDayWedInd = this.MainData.WeekDayWedInd;
				this.WeekDayThuInd = this.MainData.WeekDayThuInd;
				this.WeekDayFriInd = this.MainData.WeekDayFriInd;
				this.WeekDaySatInd = this.MainData.WeekDaySatInd;
				this.MonthEveryDOM = this.MainData.MonthEveryDOM <= 0 ? 1 : this.MainData.MonthEveryDOM;
				this.MonthEveryRecurCount = this.MainData.MonthEveryRecurCount <= 0 ? 1 : this.MainData.MonthEveryRecurCount;
				this.MonthOnWeekNbr = this.MainData.MonthOnWeekNbr <= 0 ? 1 : this.MainData.MonthOnWeekNbr;
				this.MonthOnDOW = this.MainData.MonthOnDOW; //0 = Sun
				this.MonthOnRecurCount = this.MainData.MonthOnRecurCount <= 0 ? 1 : this.MainData.MonthOnRecurCount;
				this.YearEveryMOY = this.MainData.YearEveryMOY <= 0 ? 1 : this.MainData.YearEveryMOY;
				this.YearEveryDOM = this.MainData.YearEveryDOM <= 0 ? 1 : this.MainData.YearEveryDOM;
				this.YearOnWeekNbr = this.MainData.YearOnWeekNbr <= 0 ? 1 : this.MainData.YearOnWeekNbr;
				this.YearOnDOW = this.MainData.YearOnDOW; //0 = Sun
				this.YearOnMonth = this.MainData.YearOnMonth <= 0 ? 1 : this.MainData.YearOnMonth;
				this.RangeStartDate = new Date(this.MainData.RangeStartDate);
				this.RangeEndOccurancesTotal = this.MainData.RangeEndOccurancesTotal <= 0 ? 1 : this.MainData.RangeEndOccurancesTotal;
				this.RangeEndDate = reDate;
				this.RecurrancePatternTypeID = this.MainData.RecurrancePatternTypeID <= 0 ? 1 : this.MainData.RecurrancePatternTypeID;
				this.RecurranceRangeTypeID = this.MainData.RecurranceRangeTypeID;

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	loadEvent() {
		this.loading = true;

		var result = this.defineService.C9DefineEventGet(this.EventID);
		result.subscribe(
			(response) => {
				this.MainData = response[0];

				var specTime = false;

				var doorTime = new Date(this.MainData.EventDescription.DoorsOpenTime);
				var sTime = new Date(this.MainData.EventDescription.StartTime);

				//Specify doors open time if it is different from start time
				specTime = moment(doorTime).format("HH:mm") == moment(sTime).format("HH:mm") ? false : true;

				//
				// Update fields
				//
				this.EventDescShort = this.MainData.EventDescription.EventDescShort;
				this.EventDescLong = this.MainData.EventDescription.EventDescLong;
				this.EventLocation = this.MainData.EventDescription.EventLocation;
				this.EventDT = new Date(this.MainData.EventDT);
				this.SpecifyGateOpenTime = specTime;
				this.GatesOpenTime = new Date(this.MainData.EventDescription.DoorsOpenTime);
				this.StartTime = new Date(this.MainData.EventDescription.StartTime);
				this.EndTime = new Date(this.MainData.EventDescription.EndTime);
				this.ValidationCheckOnly = this.MainData.EventDescription.ValidateOnly;

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}
	///////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////////
	onAdd() {
		//
		// Error handling
		//
		if (this.EventDescShort == "") {
			this.errorMessage = "Enter a valid Event Code";
			return;
		}
		if (this.EventDescShort.length > 20) {
			this.errorMessage = "Event Code can't be more than 20 characters";
			return;
		}

		if (this.EventDescLong == "") {
			this.errorMessage = "Enter a valid Event Name";
			return;
		}
		if (this.EventDescLong.length > 20) {
			this.errorMessage = "Event Name can't be more than 255 characters";
			return;
		}

		if (this.EventLocation == "") {
			this.errorMessage = "Enter a valid Event Location";
			return;
		}
		if (this.EventLocation.length > 50) {
			this.errorMessage = "Event Location can't be more than 50 characters";
			return;
		}

		var fev: any = moment(this.EventDT).format("MM/DD/YYYY HH:mm:00");

		if (this.RecurranceTypeID == 0 && String(fev).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Enter a valid Event Date/Time";
			return;
		}

		var fgt: any = moment(this.GatesOpenTime).format("HH:mm:00");

		if (this.SpecifyGateOpenTime == true && String(fgt).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Enter a valid Gate Open Time";
			return;
		}

		var fst: any = moment(this.GatesOpenTime).format("HH:mm:00");

		if (String(fst).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Enter a valid Start Time";
			return;
		}

		var fet: any = moment(this.EndTime).format("HH:mm:00");

		if (String(fet).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Enter a valid End Time";
			return;
		}

		if (this.RecurranceTypeID > 0) {
			if (this.RecurranceTypeID == 1) {
				if (
					this.WeekDayMonInd == false &&
					this.WeekDayTueInd == false &&
					this.WeekDayWedInd == false &&
					this.WeekDayThuInd == false &&
					this.WeekDayFriInd == false &&
					this.WeekDaySatInd == false &&
					this.WeekDaySunInd == false
				) {
					this.errorMessage = "Select at least 1 Week Day that the event will occur on";
					return;
				}
			}

			var rs: any = moment(this.RangeStartDate).format("MM/DD/YYYY HH:mm:00");

			if (String(rs).toLowerCase().indexOf("invalid") != -1) {
				this.errorMessage = "Enter a valid Range Start Date";
				return;
			}

			var re: any = moment(this.RangeEndDate).format("MM/DD/YYYY HH:mm:00");

			if (this.RecurranceRangeTypeID == 3 && String(re).toLowerCase().indexOf("invalid") != -1) {
				this.errorMessage = "Enter a valid Range End Date";
				return;
			}
		}

		//
		// Call Method
		//

		if (this.RecurranceTypeID == 0) {
			this.UpdateOneTime();
		} else {
			this.UpdateSchedule();
		}
	}

	UpdateOneTime() {
		this.Saving = true;

		//
		// Create Request
		//

		var fdot: any = moment(this.GatesOpenTime).format("MM/DD/YYYY HH:mm:00");
		var fstart: any = moment(this.StartTime).format("MM/DD/YYYY HH:mm:00");
		var fend: any = moment(this.EndTime).format("MM/DD/YYYY HH:mm:00");
		var fev: any = moment(this.EventDT).format("MM/DD/YYYY HH:mm:00");

		let parms: UpdateEventRequest = {
			EventID: this.EventID,
			EventDescriptionID: this.EventDescriptionID,
			SchoolID: this.SchoolID,
			EventDescShort: this.EventDescShort,
			EventDescLong: this.EventDescLong,
			EventLocation: this.EventLocation,
			DoorsOpenTime: this.SpecifyGateOpenTime == true ? fdot : fstart,
			StartTime: fstart,
			EndTime: fend,
			EventScanCausesAttendance: 0,
			ValidateOnly: this.ValidationCheckOnly == true ? 1 : 0,
			EventDT: fev,
		};

		var result = this.defineService.C9DefineEventUpdate(parms);
		result.subscribe(
			(response) => {
				this.Saving = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Event updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Event",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Saving = false;
			}
		);
	}

	UpdateSchedule() {
		this.Saving = true;

		//
		// Create Request
		//

		var fdot: any = moment(this.GatesOpenTime).format("MM/DD/YYYY HH:mm:00");
		var fstart: any = moment(this.StartTime).format("MM/DD/YYYY HH:mm:00");
		var fend: any = moment(this.EndTime).format("MM/DD/YYYY HH:mm:00");
		// var fev: any = moment(this.EventDT).format("MM/DD/YYYY HH:mm:00");

		var frsdate: any = moment(this.RangeStartDate).format("MM/DD/YYYY");
		var fedate: any = moment(this.RangeEndDate).format("MM/DD/YYYY");

		let parms: UpdateScheduleRequest = {
			ScheduleID: this.ScheduleID,
			EventDescriptionID: this.EventDescriptionID,
			SchoolID: this.SchoolID,
			EventDescShort: this.EventDescShort,
			EventDescLong: this.EventDescLong,
			EventLocation: this.EventLocation,
			DoorsOpenTime: this.SpecifyGateOpenTime == true ? fdot : fstart,
			StartTime: fstart,
			EndTime: fend,
			EventScanCausesAttendance: 0,
			ValidateOnly: this.ValidationCheckOnly == true ? 1 : 0,
			RecurranceTypeID: this.RecurranceTypeID,
			RecurrancePatternTypeID: this.RecurrancePatternTypeID,
			RecurranceRangeTypeID: this.RecurranceRangeTypeID,
			WeekRecurCount: this.RecurranceTypeID == 1 ? this.WeekRecurCount : 0,
			WeekDaySunInd: this.RecurranceTypeID == 1 && this.WeekDaySunInd == true ? 1 : 0,
			WeekDayMonInd: this.RecurranceTypeID == 1 && this.WeekDayMonInd == true ? 1 : 0,
			WeekDayTueInd: this.RecurranceTypeID == 1 && this.WeekDayTueInd == true ? 1 : 0,
			WeekDayWedInd: this.RecurranceTypeID == 1 && this.WeekDayWedInd == true ? 1 : 0,
			WeekDayThuInd: this.RecurranceTypeID == 1 && this.WeekDayThuInd == true ? 1 : 0,
			WeekDayFriInd: this.RecurranceTypeID == 1 && this.WeekDayFriInd == true ? 1 : 0,
			WeekDaySatInd: this.RecurranceTypeID == 1 && this.WeekDaySatInd == true ? 1 : 0,
			MonthEveryDOM: this.RecurranceTypeID == 2 && this.RecurrancePatternTypeID == 1 ? this.MonthEveryDOM : 0,
			MonthEveryRecurCount: this.RecurranceTypeID == 2 && this.RecurrancePatternTypeID == 1 ? this.MonthEveryRecurCount : 0,
			MonthOnWeekNbr: this.RecurranceTypeID == 2 && this.RecurrancePatternTypeID == 2 ? this.MonthOnWeekNbr : 0,
			MonthOnDOW: this.RecurranceTypeID == 2 && this.RecurrancePatternTypeID == 2 ? this.MonthOnDOW : 0,
			MonthOnRecurCount: this.RecurranceTypeID == 2 && this.RecurrancePatternTypeID == 2 ? this.MonthOnRecurCount : 0,
			YearEveryMOY: this.RecurranceTypeID == 3 && this.RecurrancePatternTypeID == 1 ? this.YearEveryMOY : 0,
			YearEveryDOM: this.RecurranceTypeID == 3 && this.RecurrancePatternTypeID == 1 ? this.YearEveryDOM : 0,
			YearOnWeekNbr: this.RecurranceTypeID == 3 && this.RecurrancePatternTypeID == 2 ? this.YearOnWeekNbr : 0,
			YearOnDOW: this.RecurranceTypeID == 3 && this.RecurrancePatternTypeID == 2 ? this.YearOnDOW : 0,
			YearOnMonth: this.RecurranceTypeID == 3 && this.RecurrancePatternTypeID == 2 ? this.YearOnMonth : 0,
			RangeStartDate: frsdate,
			RangeEndOccurancesTotal: this.RecurranceRangeTypeID == 2 ? this.RangeEndOccurancesTotal : 0,
			RangeEndDate: this.RecurranceRangeTypeID == 3 ? fedate : "",
			ScheduleTime: "",
		};

		var result = this.defineService.C9ScheduleUpdate(parms);
		result.subscribe(
			(response) => {
				this.Saving = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Event updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Event",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Saving = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////
}
